import { ProxyGraphClients, abgGraphqlClient as graphqlClient } from '@atlassian/temp-client-utils';
import {
  FetchNativeProductCollectionForChangeSubscriptionQuery,
  FetchNativeProductCollectionForChangeSubscriptionQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-sxp';
import { TEAMWORK_COLLECTION_PRODUCT_ID } from '@css-xp/ppc-constants';
import { fetchNativeProductCollectionForChangeSubscription } from '../../queries/sxp/fetch-native-product-collection-for-change-subscription';
import { CartProductSchema, CollectionToInstanceOfferingMapResponse } from '../../types';

/**
 * Fetches the collection to instance offering map
 * For the given collection offering id, fetches the instances offerings
 * @returns CollectionToInstanceOfferingMapResponse
 */
export async function getCollectionToInstanceOfferingMap() {
  const response = await graphqlClient(ProxyGraphClients.SXP).query<
    FetchNativeProductCollectionForChangeSubscriptionQuery,
    FetchNativeProductCollectionForChangeSubscriptionQueryVariables
  >({
    query: fetchNativeProductCollectionForChangeSubscription,
    variables: {
      productKey: TEAMWORK_COLLECTION_PRODUCT_ID,
    },
    fetchPolicy: 'cache-first',
  });

  return response;
}

/**
 * Function to get the product id to offering id map for instances of a collection
 * @returns Record<string, string>
 * Product Id to corresposnding offering Id map
 */
export async function getCollectionInstanceProductIdOfferingIdMap({
  collectionToInstanceOfferingMap,
  requestOfferingId,
  orgProductInstances,
}: {
  collectionToInstanceOfferingMap?: CollectionToInstanceOfferingMapResponse;
  requestOfferingId: string;
  orgProductInstances: CartProductSchema[];
}) {
  if (!collectionToInstanceOfferingMap || orgProductInstances?.length === 0) {
    return {};
  }

  const offeringCollections =
    collectionToInstanceOfferingMap?.data?.nativeCatalogForCollection?.nodes[0]?.offeringCollections;

  const productOfferingsForCollection =
    collectionToInstanceOfferingMap?.data?.nativeCatalogForCollection?.nodes[0]?.productOfferingsForCollection;

  const instancesOfferingIdsBasedOnParentOffering = offeringCollections?.find(
    (offering) => requestOfferingId && offering?.id === requestOfferingId
  )?.toOfferingIds;

  let productIdToOfferingIdMap: Record<string, string> = {};

  orgProductInstances?.forEach((instance) => {
    const currentProductOfferings = productOfferingsForCollection?.filter(
      (productOffering) => productOffering?.product?.id === instance?.productId
    );

    const destinationOffering = currentProductOfferings?.find(
      (productOffering) =>
        productOffering?.id && instancesOfferingIdsBasedOnParentOffering?.includes(productOffering?.id)
    );

    if (destinationOffering) {
      productIdToOfferingIdMap = {
        ...productIdToOfferingIdMap,
        [instance.productId]: destinationOffering.id,
      };
    }
  });

  return productIdToOfferingIdMap;
}
